import { render, staticRenderFns } from "./ClinicProfile.vue?vue&type=template&id=205c70c6&scoped=true"
import script from "./ClinicProfile.vue?vue&type=script&lang=js"
export * from "./ClinicProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205c70c6",
  null
  
)

export default component.exports